import React from "react";
import { Outlet } from "react-router-dom";

// components

import Navbar from "../components/Shared/Navbars/AuthNavbar.jsx";
import FooterSmall from "../components/Shared/Footers/FooterSmall.jsx";
import Toast from '../components/Shared/Toasts/Toast.jsx';

export default function Auth() {
  return (
    <>
      <Navbar transparent />
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-slate-700 bg-no-repeat bg-full"
            style={{
              background:
                "linear-gradient(to top, #30cfd0 0%, #330867 100%)",
            }}
          ></div>
          <Outlet />
          <FooterSmall absolute />
        </section>
      </main>
      <Toast />
    </>
  );
}
